import React from 'react';
import { Messages } from './Messages';
import { Details } from './Details';
import { ContentWrapper } from '../../styles/sideContainerStyles';

export function Content(): JSX.Element {
  return (
    <ContentWrapper>
      <Messages />
      <Details />
    </ContentWrapper>
  );
}
